
export default function ProblemSection() {
  const problems = [
    {
      icon: 'ri-time-line',
      title: '停止のたびに粗利が蒸発',
      description: '1分の停止×ライン本数×日数＝年ベースで数百万円～',
      impact: '時間ロス'
    },
    {
      icon: 'ri-error-warning-line',
      title: '"人の手"のバラつき',
      description: '締付け不一致→ppm悪化・手戻り・顧客監査で挟み撃ち',
      impact: '品質リスク'
    },
    {
      icon: 'ri-team-line',
      title: '技能者依存の綱渡り',
      description: '欠員・異動で段取り崩壊→納期遅延',
      impact: '属人化リスク'
    },
    {
      icon: 'ri-file-search-line',
      title: '"証拠"が無い',
      description: '再現性と履歴の説明ができず、価格交渉で常に不利',
      impact: '競争力低下'
    }
  ];

  return (
    <section className="py-20 bg-red-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-red-700 mb-4">
            【警告：今すぐ向き合うべき現実】
          </h2>
          <p className="text-xl text-red-600 font-semibold">
            対策が遅れるほど、利益は静かに漏れ続けます。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((problem, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-lg border-l-4 border-red-500">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                  <i className={`${problem.icon} text-2xl text-red-600`}></i>
                </div>
                <div className="ml-3">
                  <span className="text-xs font-semibold text-red-500 uppercase tracking-wide">
                    {problem.impact}
                  </span>
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {problem.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-red-600 text-white p-8 rounded-lg inline-block">
            <h3 className="text-2xl font-bold mb-2">年間損失額の例</h3>
            <p className="text-lg">
              40分作業 × 15回/日 × 250日 × ¥4,000/時間 = <span className="text-yellow-300 font-bold text-xl">年間1000万円</span>
            </p>
            <p className="text-sm mt-2 opacity-90">※これは工作機械1台分の一例、企業が人件費に掛かるトータルコストを4,000円／時とした場合の計算</p>
          </div>
        </div>
      </div>
    </section>
  );
}
